'use strict';

var $                       = require('jquery');
var Core                    = require('../core/core.js');
var InspectorTextInput      = require('./inspector__textinput.js');
var InspectorValueUnit      = require('./inspector__valueunit.js');
var InspectorValueUnitFixed = require('./inspector__valueunitfixed.js');
var InspectorValueUnitCheck = require('./inspector__valueunitcheck.js');
var InspectorButton         = require('./inspector__button.js');
var InspectorReadOnly       = require('./inspector__readonly.js');
var InspectorImage          = require('./inspector__image.js');
var InspectorSelectableImageGroup     = require('./inspector__selectable__imagegroup.js');
var InspectorSpinner        = require('./inspector__spinner.js');
var InspectorCheckbox       = require('./inspector__checkbox.js');
var InspectorSelectbox      = require('./inspector__selectbox.js');
var InspectorSlider 		= require('./inspector__slider.js');
var InspectorSliderAdvanced = require('./inspector__slider_advanced.js');
var InspectorButton         = require('./inspector__button.js');
var InspectorButtonGroup    = require('./inspector__buttongroup.js');
var InspectorCommonControls = require('./inspector__commoncontrols.js');
var InspectorSketch2D       = require('./inspector__sketch2d.js');
var InspectorLabel 			= require('./inspector__label.js');
var InspectorRow    		= require('./inspector__row.js');

/**
 * Creates an inspector
 *
 * @class
 */

class InspectorGroup extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'theme': 'dark'
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
			<div class="editor__inspector__group js-editor__inspector__group <%- theme %>"></div>
		`;

		super.render();
	}

	addCommonControls() {
		return new InspectorCommonControls({
			target: this.$el,
			fields: {}
		});
	}

	addTextInput(title, value, tooltip){
		return new InspectorTextInput({
			target: this.$el,
			fields: {
				'title': title,
				'value': value,
				'tooltip': tooltip
			}
		});
	}

	addValueUnit(title, value, units, tooltip){
		return new InspectorValueUnit({
			target: this.$el,
			fields: {
				'title': title,
				'value': value,
				'units': units,
				'tooltip': tooltip
			}
		});
	}

	addValueUnitFixed(title, value, units, tooltip){
		return new InspectorValueUnitFixed({
			target: this.$el,
			fields: {
				'title': title,
				'value': value,
				'unit': units,
				'tooltip': tooltip
			}
		});
	}

	addValueUnitCheck(title, value, units, checked, tooltip){
		return new InspectorValueUnitCheck({
			target: this.$el,
			fields: {
				'title': title,
				'value': value,
				'units': units,
				'checked': checked,
				'tooltip': tooltip
			}
		});
	}

	addReadOnly(title, value, tooltip){
		return new InspectorReadOnly({
			target: this.$el,
			fields: {
				'title': title,
				'value': value,
				'tooltip': tooltip
			}
		});
	}

	addImage(title, value, tooltip){
        return new InspectorImage({
            target: this.$el,
            fields: {
                'title': title,
                'value': value,
                'tooltip': tooltip
            }
        });
    }

    addSelectableImageGroup(title, tooltip, readOnly){
		return new InspectorSelectableImageGroup({
			target: this.$el,
			fields: {
				'title': title,
				'tooltip': tooltip,
				'read_only': readOnly
			}
		});
	}

	addSpinner(title){
		return new InspectorSpinner({
			target: this.$el,
			fields: {
				'title': title
			}
		});
	}

	addCheckbox(title, checked, tooltip, readOnly){
		return new InspectorCheckbox({
			target: this.$el,
			fields: {
				'title': title,
				'checked': checked,
				'tooltip': tooltip,
                'read_only': readOnly
			}
		});
	}

	addButton(title, icon, tooltip){
		return new InspectorButton({
			target: this.$el,
			fields: {
				'title': title,
                'icon' : icon,
                'tooltip': tooltip
			}
		});
	}

	addButtonGroup(){
		return new InspectorButtonGroup({
			target: this.$el,
			fields: {}
		});
	}

	addSelectbox(title, options, tooltip, readOnly){
		return new InspectorSelectbox({
			target: this.$el,
			fields: {
				'title': title,
				'options': options,
				'tooltip': tooltip,
                'read_only': readOnly
			}
		}, false);
	}

	addSlider(title, value, min, max, steps, ticks, showtext, orientation, displayUnit, tooltip) {
		return new InspectorSlider({
			target: this.$el,
			fields: {
				'title': title,
				'value': value,
                'min': min,
                'max': max,
				'steps': steps,
				'tooltip': tooltip
			}
		});
	}

	addSketch2D(width, height) {
		return new InspectorSketch2D({
			target: this.$el,
			fields: {
				'width': width,
				'height': height
			}
		});
	}

	addFileUpload(id, editorParent, config, accept, maxSize, uploadUrl) {
		// InspectorFileManager is not defined anywhere in our source!
		return new InspectorFileManager({
	       "id": id || 'fileUpload',
	       "target": this.$el,
	       "editorParent": editorParent,
	       "config": config,
	       "accept": accept,
	       "maxSize": maxSize,
	       "uploadUrl" : uploadUrl
	   });
	}

	addLabel(label, tooltip){
		return new InspectorLabel({
			target: this.$el,
			fields: {
				'title': label,
				'tooltip': tooltip
			}
		});
	}

	addRow(notFlexContainer) {
		return new InspectorRow({
			target: this.$el,
			fields: {
				'notFlexContainer': notFlexContainer
			}
		});
	}
}
module.exports = InspectorGroup;
